import { useSuspenseQuery } from '@tanstack/react-query';
import { paths } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';

export type UserPreferencesResponse =
  paths['/user/preferences']['get']['responses']['200']['content']['application/json'];
export type UserPreferences = UserPreferencesResponse['data']['features'];

const fetchUserPreferences = async (): Promise<UserPreferences> => {
  const userPreferences = await apiClient
    .get('api/supplier-experience/user/preferences')
    .json<UserPreferencesResponse>();

  return userPreferences.data.features;
};

export default function useUserPreferences<TData = UserPreferences>(
  select?: (data: UserPreferences) => TData,
  options?: { enabled?: boolean }
) {
  const enabled = options?.enabled ?? true;

  return useSuspenseQuery({
    queryKey: ['user-preferences', enabled],
    queryFn: enabled ? fetchUserPreferences : () => Promise.resolve({} as UserPreferences),
    select,
    ...options,
  });
}
